
import React from 'react';
import { List } from '@mui/material';

export default function FileList({ children }: { children: React.ReactNode }) {
  return <List sx={{ width: '100%', maxWidth: 600 }}>{children}</List>;
}
